import React, { Component } from 'react';
import GaleriaDeAppsItem from './GaleriaDeAppsItem';

import PubSub from 'pubsub-js';

import '../css/GaleriaDeApps.css';

class GaleriaDeApps extends Component {
  constructor(){
    super();
    this.state = {
      apps : [],
      lang : 'pt'
    };

    
    this.locationTexts= {
      "mais-aplicativos" : {"pt" : "Mais Aplicativos", "es": "Más Aplicaciones", "en": "More Applications"}
    };
  }

  componentWillReceiveProps(props) {
    this.setState({apps : props.apps});
  }

  componentWillMount(){
      PubSub.subscribe('language.change', (msg, lang) => this.setState({lang}));
  }

  render() { 
    const texts= this.locationTexts;  
    return (                    
          <section id="galeriaDeApps">
            <div className="galeriaDeApps-title">{texts["mais-aplicativos"][this.state.lang]}</div>
            <div id="galeriaDeApps-apps">          
              {this.state.apps.map(app => <GaleriaDeAppsItem app={app} key={app.id} />)}
            </div>
          </section>
    );
  }
}

export default GaleriaDeApps;



// WEBPACK FOOTER //
// ./src/componentes/GaleriaDeApps.js